<!--
 * @Description: 
 * @Author: xgx
 * @Date: 2023-05-23 14:52:38
 * @LastEditors: xgx
 * @LastEditTime: 2023-07-06 09:34:43
-->
<template>
   <div>
      <a-drawer
    title="监测配置（首页不更新）"
    :visible="visible"
    :width="width<=1000?'90%':'900px'"
    @close="onClose"
  >
    <div class="title-box">
      <i class="el-icon-info icon-title"></i>
      <div>
        <div>
          1. 监测两周，首页无信息更新的，即单项否决（无发布时间视为不更新）。
        </div>
        <div>
          2.
          如首页仅为网站栏目导航入口，所有二级页面无信息更新的，即单项否决（无发布时间视为不更新）。
        </div>
      </div>
    </div>
    <div class="btn-box">
      <div @click="updateModel" class="btn">编辑</div>
      <div>更新周期：两周</div>
    </div>
    <coententTable
      :columns="columns"
      :dataSource="dataSource"
      :loading="loading"
      :customSlot="customSlot"
      :pagination="false"
      :y="height"
    >
      <template v-slot:childrenNumber="scopeVal">
        {{
          scopeVal.scope.childrenNumber > 0
            ? scopeVal.scope.childrenNumber
            : "—"
        }}
      </template>
    </coententTable>
    
  </a-drawer>
  <HomeColumnModel @cancellation="cancellation" :dataSource="dataSource" v-if="dialogVisible" @handleClose="handleClose" :dialogVisible="dialogVisible"></HomeColumnModel>
   </div>
</template>

<script>
import { indexColumnConfigList } from "../index";
import coententTable from "@/components/coentent_table.vue";
import HomeColumnModel from './home_column_model.vue'
export default {
  data() {
    return {
      columns: [
        {
          title: "序号",
          dataIndex: "num",
          ellipsis: true,
          width: 80,
           fixed: "left",
        },
        {
          title: "栏目路径",
          dataIndex: "columnName",
          ellipsis: true,
          width: 500,
        },
        {
          title: "子栏目",
          dataIndex: "childrenNumber",
          ellipsis: true,
          width: 100,
          fixed: "right",
          scopedSlots: { customRender: "childrenNumber" },
        },
      ],
      customSlot: [
        {
          name: "childrenNumber",
          customRender: "childrenNumber",
        },
      ],
      dataSource: [],
      loading: false,
      height:0,
      dialogVisible:false,
      width:'',
    };
  },
  components: {
    coententTable,
    HomeColumnModel,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    
  },
  watch:{
    visible(val){
        if(val){
          this.getList();
          this.height = document.documentElement.clientHeight - 280;
          this.width = document.documentElement.clientWidth;
          window.onresize = () => {
            return (() => {
              this.height = document.documentElement.clientHeight - 280;
              this.width  = document.documentElement.clientWidth;
            })();
          };
        }
    }
  },
  methods: {
    updateModel(){
        this.dialogVisible = true;
    },
    onClose() {
      this.dataSource = [];
      this.$emit("onClose");
    },
    handleClose(){
       this.dialogVisible = false;
       this.getList()
    },
    cancellation(){
      this.dialogVisible = false;
    },
    getList() {
      this.loading = true;
      indexColumnConfigList({
        siteId: sessionStorage.getItem("siteId"),
      }).then((res) => {
        this.dataSource = res.data;
        this.loading = false;
        for (let index = 0; index < this.dataSource.length; index++) {
          const element = this.dataSource[index];
          element.num = index + 1;
        }
        this.height = document.documentElement.clientHeight - 300;
        window.onresize = () => {
          return (() => {
            this.height = document.documentElement.clientHeight - 300;
          })();
        };
      });
    },
  },
};
</script>

<style lang="less" scoped>
/deep/ .ant-drawer-title {
  color: rgba(48, 49, 51, 1);
  font-size: 18px;
  text-align: left;
  font-family: Roboto-black;
  font-weight: bold;
}
.title-box {
  display: flex;
  border-radius: 4px;
  background-color: rgba(244, 244, 245, 1);
  padding: 8px 10px;
  color: rgba(144, 147, 153, 1);
  font-size: 13px;
  text-align: left;
  font-family: HarmonyOS_Sans_SC-regular;
  .icon-title {
    color: #a9aab1;
    transform: rotate(-13deg);
    margin-top: 1px;
    margin-right: 2px;
  }
  /deep/ .anticon-close {
    color: rgba(48, 49, 51, 1);
    font-size: 20px;
    font-weight: bold;
  }
}
.btn-box {
  display: flex;
  align-items: center;
  margin: 20px 0px;
  .btn {
    width: 68px;
    height: 36px;
    line-height: 20px;
    border-radius: 4px;
    background-color: rgba(24, 109, 230, 1);
    text-align: center;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    color: rgba(255, 255, 255, 1);
    font-size: 14px;
    margin-right: 14px;
  }
}
/deep/ .table {
  margin: 0;
}
/deep/.ant-drawer-close{
    font-size: 16px;
    color: rgba(48, 49, 51, 1);
    font-weight: 800;
}
/deep/.ant-drawer-content{
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
}
</style>